/**
 * PreviewSplitLayout — editor left, live preview right.
 */

import { FC, ReactNode } from 'react';

import { cn } from '@/lib/utils';

export interface PreviewSplitLayoutProps {
  active: boolean;
  panel: ReactNode;
  children: ReactNode;
  /** The panel's width from lg up (default the Flow Optimizer's 26rem). */
  panelWidthClass?: string;
}

const PreviewSplitLayout: FC<PreviewSplitLayoutProps> = ({
  active,
  panel,
  children,
  panelWidthClass = 'lg:w-[26rem]',
}) => (
  <div
    className={cn(
      'flex min-h-0 flex-1 flex-col overflow-hidden',
      active && 'lg:flex-row lg:gap-0',
    )}
  >
    <div
      className={cn(
        'min-h-0 min-w-0 flex-1 overflow-y-auto pb-4',
        active && 'lg:pr-3',
      )}
    >
      {children}
    </div>
    {active ? (
      <aside className={cn('flex min-h-0 w-full flex-col border-t border-border/60 pt-2 lg:shrink-0 lg:border-l lg:border-t-0 lg:pl-3 lg:pt-0', panelWidthClass)}>
        {panel}
      </aside>
    ) : null}
  </div>
);

export default PreviewSplitLayout;
